class BaseCommunicator {
    getLocale() {
        throw new Error("Not implemented");
    }

    getMeinJenaUser() {
        throw new Error("Not implemented");
    }

    openMail() {
        throw new Error("Not implemented");
    }

    setPageTitle(data) {
        throw new Error("Not implemented");
    }

    refreshToken() {
        throw new Error("Not implemented");
    }

    reportError(title, message) {
        throw new Error("Not implemented");
    }

    openExternalBrowser(url) {
        throw new Error("Not implemented");
    }

    openInternalBrowser(url, title, showShareButton, showNavigationButtons, showCrossBackNavigationAndroid, isNavWhite) {
        throw new Error("Not implemented");
    }

    trackPageImpression(pageName) {
        throw new Error("Not implemented");
    }

    trackEvent(action, category, label) {
        throw new Error("Not implemented");
    }
}

export default BaseCommunicator;
